import { render, staticRenderFns } from "./HomeworkView.vue?vue&type=template&id=4c7b2cf6&"
import script from "./HomeworkView.vue?vue&type=script&lang=js&"
export * from "./HomeworkView.vue?vue&type=script&lang=js&"
import style0 from "./HomeworkView.vue?vue&type=style&index=0&id=4c7b2cf6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports